import * as React from 'react';
import { UseContainerWidthReturn } from '../types';

// 🎯 Single Responsibility Principle (SRP)
// Este hook SOLO maneja el ancho del contenedor con ResizeObserver

interface UseContainerWidthOptions {
  initialWidth?: number;
  debounceMs?: number;
}

export const useContainerWidth = (
  ref: React.RefObject<HTMLDivElement | null>,
  options: UseContainerWidthOptions = {}
): UseContainerWidthReturn => {
  const { initialWidth = 0, debounceMs = 16 } = options;
  
  const [width, setWidth] = React.useState(initialWidth);
  const timeoutRef = React.useRef<NodeJS.Timeout | undefined>(undefined);

  React.useEffect(() => {
    const updateWidth = () => {
      if (ref.current) {
        const newWidth = ref.current.clientWidth;
        
        // 🎯 Debounce para performance en resize frecuentes
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        
        timeoutRef.current = setTimeout(() => {
          setWidth(newWidth);
        }, debounceMs);
      }
    };

    // Medición inicial
    updateWidth();
    
    // ResizeObserver para cambios dinámicos
    const resizeObserver = new ResizeObserver(updateWidth);
    
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    // Cleanup
    return () => {
      resizeObserver.disconnect();
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [ref, debounceMs]);

  return { width };
}; 